import { render, staticRenderFns } from "./ViewCheckoffSummary.vue?vue&type=template&id=64c61c0a"
import script from "./ViewCheckoffSummary.vue?vue&type=script&lang=js"
export * from "./ViewCheckoffSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports